import { IsDefined, IsOptional, IsString, Length } from 'class-validator';

export class PriceListDeleteRequest {
    @IsDefined()
    @IsString()
    @Length(36, 36)
    public priceTypeUuid!: string;

    @IsOptional()
    @IsString()
    @Length(36, 36)
    public replacePriceTypeUuid?: string;

    constructor(data?: Partial<PriceListDeleteRequest>) {
        this.priceTypeUuid = data?.priceTypeUuid;
        this.replacePriceTypeUuid = data?.replacePriceTypeUuid;
    }
}
